export default "__VITE_ASSET__DdW2Kx6C__"